<template>
    <lb-drawer
        data-testid="transaction-matching-config-new__add-update-filter-drawer"
        :value="dialog"
        @input="$emit('update:dialog', $event)"
        :heading="heading"
        width="600"
        :loading="loading"
    >
        <template v-slot:body>
            <div>
                <v-row>
                    <v-col cols="12" class="my-0 py-0">
                        <p class="ma-0 mb-1">Description*</p>
                        <lb-textBox
                            data-testid="transaction-matching-config-new__filter-description-input"
                            requriedrows="3"
                            v-model.trim="item.description"
                            label=""
                            placeholder="Enter description"
                            :error="errorItem.description"
                        />
                    </v-col>
                    <v-col cols="12" class="my-0 py-0">
                        <p class="ma-0 mb-1">Tag*</p>
                        <lb-string
                            data-testid="transaction-matching-config-new__filter-tag-input"
                            v-model.trim="item.tag"
                            label=""
                            placeholder="Enter Tag"
                            :error="errorItem.tag"
                        />
                    </v-col>
                    <v-col cols="6" class="my-0 py-0 mb-4">
                        <span>Whether to exclude or delete the row:</span>
                    </v-col>
                    <v-col cols="6" class="my-0 py-0 mb-4">
                        <v-radio-group
                            data-testid="transaction-matching-config-new__filter-exclude-type-radio"
                            v-model="item.excludetype"
                            row
                            class="pt-0 mt-0"
                            dense
                            hide-details
                            :error-messages="errorItem.excludetype"
                            :error="errorItem.excludetype"
                        >
                            <v-radio
                                v-for="(v, i) in excludeTypes"
                                :key="i"
                                :label="v"
                                class="my-0"
                                :value="v"
                                :id="'automation-test-'+ i"
                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="6" class="my-0 py-0">
                        <p class="ma-0 mb-1">Select Table*</p>
                        <lb-dropdown
                            data-testid="transaction-matching-config-new__filter-table-dropdown"
                            class="flux-grow-1 mr-1"
                            label=""
                            placeholder="Select Table"
                            :items="tables"
                            itemtext="name"
                            itemvalue="_id"
                            v-model="item.tableid"
                            :error="errorItem.tableid"
                        />
                    </v-col>
                    <v-col cols="6" class="my-0 py-0">
                        <p class="ma-0 mb-1">Select Column*</p>
                        <lb-dropdown
                            data-testid="transaction-matching-config-new__filter-column-dropdown"
                            class="flux-grow-1 mr-1"
                            label=""
                            placeholder="Select Column"
                            :items="dynamicColumns"
                            v-model="item.column"
                            :error="errorItem.column"
                        />
                    </v-col>
                    <v-col cols="12" class="my-0 py-0">
                        <p class="ma-0 mb-1">Filter Criteria*</p>
                        <lb-dropdown
                            data-testid="transaction-matching-config-new__filter-criteria-dropdown"
                            class="flux-grow-1 mr-1"
                            label=""
                            placeholder="Filter Criteria"
                            :items="operators"
                            itemtext="name"
                            itemvalue="_id"
                            v-model="item.operator"
                            :error="errorItem.operator"
                        />
                    </v-col>
                    <v-col cols="12" class="my-0 py-0">
                        <p class="ma-0 mb-1">Filter text or number*</p>
                        <lb-string
                            data-testid="transaction-matching-config-new__filter-word-input"
                            v-model.trim="item.filterword"
                            label=""
                            placeholder=" Enter Filter text or number"
                            :error="errorItem.filterword"
                        />
                    </v-col>
                </v-row>
            </div>
        </template>
        <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn
                data-testid="transaction-matching-config-new__update-filter-button"
                color="primary"
                v-if="isEditing"
                @click="$emit('update')"
            >
                <span>Update</span>
            </v-btn>
            <v-btn
                data-testid="transaction-matching-config-new__add-filter-button"
                color="primary"
                @click="$emit('add')"
                v-else
            >
                <span>Add</span>
            </v-btn>
        </template>
    </lb-drawer>
</template>

<script>
export default {
    name: 'FilterDefinitionDrawer',
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            required: true // filterobject
        },
        errorItem: {
            type: Object,
            default: () => ({})
        },
        columns: {
            type: Array, // filtercolums
            default: () => []
        },
        operators: {
            type: Array, // operatorType
            default: () => []
        },
        excludeTypes: {
            type: Array, // filterrowType
            default: () => []
        },
        tables: {
            type: Array, // setupList.file
            default: () => []
        },
        isEditing: {
            type: Boolean,
            default: false
        },
        heading: {
            type: String,
            default: 'Add Filter'
        },
        fileConfigInfo: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            dialogJustOpened: false,
        };
    },

    computed: {
        dynamicColumns() {
            const tableId = this.item && this.item.tableid;
            if (!tableId || !this.fileConfigInfo) return this.columns || [];
            // fileConfigInfo keys are fileconfig _ids; each entry has a .file property = the actual file _id
            const entry = this.fileConfigInfo[tableId]
                || Object.values(this.fileConfigInfo).find(c => c && (c.file === tableId || c._id === tableId));
            if (entry && entry.columnmap) {
                return entry.columnmap.map(col =>
                    Array.isArray(col) ? col[1] : (col.label || col.name || col)
                ).filter(Boolean);
            }
            return this.columns || [];
        },
    },

    watch: {
        dialog(newVal, oldVal) {
            if (newVal && !oldVal) {
                // Mark that the dialog just opened so the tableid watcher
                // doesn't clear the column when the item is pre-loaded for editing
                this.dialogJustOpened = true;
                this.$nextTick(() => {
                    this.dialogJustOpened = false;
                });
            }
        },
        'item.tableid'(newVal, oldVal) {
            // Skip column reset when the dialog just opened with a pre-set tableid
            // (i.e., opening in edit mode). Only reset when the user actively
            // changes the table while the dialog is already open.
            if (this.dialogJustOpened) return;
            if (newVal !== oldVal && this.item) {
                this.item.column = '';
            }
        },
    },
};
</script>